"use client";

import { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import Image from "next/image";

interface SlideBottomProps {
  title: string;
  details: string;
  image: string;
  label: string;
  variant?: "blue" | "green";
}
interface MobileSlideProps {
  slides: SlideBottomProps[];
  isMobile?: boolean;
}

const MobileSlide: React.FC<MobileSlideProps> = ({ slides }) => {
  const swiperRef = useRef<any>(null);
  const [currentIndex, setCurrentIndex] = useState(1);
  const bgImage = (variant: "blue" | "green") =>
    variant === "green"
      ? "bg-[url('/images/ServicesInner/slider-green.png')]"
      : "bg-[url('/images/ServicesInner/slider-blue.png')]";

  return (
    <div className="relative w-full lg:hidden block">
      {/* Swiper */}
      <Swiper
        modules={[Navigation, Autoplay]}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        navigation={{
          prevEl: ".prevBtn",
          nextEl: ".nextBtn",
        }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop={true}
        onSlideChange={(swiper) => setCurrentIndex(swiper.realIndex + 1)}
        className="mySwiper"
      >
        {slides?.map((slide: any, index: number) => (
          <SwiperSlide key={index}>
            <div>
              {slide.image && (
                <Image
                  src={slide.image}
                  alt={slide.label}
                  width={500}
                  height={250}
                  loading="lazy"
                  className="w-full h-[250px] object-cover mb-[16px]"
                />
              )}
              <div className="flex justify-center border border-border xl:min-h-[425px] md:min-h-[297px] min-h-[320px] bg-background-dark h-full">
                <div
                  className={`h-full xl:px-6 px-4 xl:py-8 py-5 text-white ${bgImage(slide?.variant)} bg-no-repeat bg-contain bg-top-right`}
                >
                  <div className="xl:pb-[76px] md:pb-[50px]">
                    <h5 className="xl:text-heading-5 text-heading-6 font-bold text-primary-text-white">
                      {slide.title ?? ""}
                    </h5>
                    <p className="xl:text-subtitle-1 text-subtitle-3 font-regular text-secondary-text-white lg:mt-6 mt-4">
                      {slide.details ?? ""}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Mobile Progress Bar */}
      <div className="mt-[30px] lg:mt-[15px] lg:hidden flex justify-center items-center gap-2 px-12 py-6 sm:w-[67%] mx-auto relative">
        {slides?.map((_: any, index: number) => (
          <div
            key={index}
            className={`p-0 relative rounded overflow-hidden ${
              currentIndex - 1 === index
                ? "flex w-[128px] h-1 bg-[#E6F3FD]"
                : "flex-none w-[16px] h-1 bg-[#E6F3FD]"
            }`}
          >
            <span
              className={`absolute top-0 left-0 rounded h-1 ${
                currentIndex - 1 === index
                  ? "bg-gradient-to-r from-[#8ABC00] to-[#0086E6] transition-all duration-[5000ms] w-[128px]"
                  : "w-[16px]"
              }`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MobileSlide;
